<template>
    <div class="update-password-form">
        <a-form
                :form="form"
                layout="vertical"
        >
            <a-row>
                <a-col :span="24">
                    <a-form-item class="required"
                                 :label="$t('user.updatePasswordForm.labels.oldPassword')">
                        <pt-input type="password"
                                :placeholder="$t('user.updatePasswordForm.tips.oldPassword')"
                                v-decorator="['oldPassword',{rules: [
                  {required: true,message: $t('user.updatePasswordForm.tips.oldPassword'),},
                  {max: 16,min:6,message: $t('user.updatePasswordForm.tips.passlength'),}
                ],}]">
                        </pt-input>
                    </a-form-item>
                </a-col>
            </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item class="required"
                           :label="$t('user.updatePasswordForm.labels.password')">
                <pt-input  type="password"
                  :placeholder="$t('user.updatePasswordForm.tips.password')"
                  v-decorator="['password',{rules: [
                  {required: true,message: $t('user.updatePasswordForm.tips.password'),},
                  {max: 16,min:6,message: $t('user.updatePasswordForm.tips.passlength'),},
                  {validator: validateToNextPassword,}
                ],}]">
                </pt-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item class="required"
                           :label="$t('user.updatePasswordForm.labels.configPassword')">
                <pt-input  type="password"
                  :placeholder="$t('user.updatePasswordForm.tips.configPassword')"
                  v-decorator="['configPassword',{rules: [
                  {required: true,message: $t('user.updatePasswordForm.tips.configPassword'),},
                  {max: 16,min:6,message: $t('user.updatePasswordForm.tips.passlength'),},
                  {validator: compareToFirstPassword,},
                ],}]">
                </pt-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
    </div>
</template>

<script>
  import md5 from 'md5'
  export default {
    name: '',
    beforeCreate() {
      this.form = this.$form.createForm(this)
    },
    data() {
      return {
        confirmDirty: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        }
      }
    },
    mounted() {
      this.form.setFieldsValue()
    },
    methods: {
      compareToFirstPassword(rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback(this.$t('user.updatePasswordForm.tips.towPasswrod'));
        } else {
          callback();
        }
      },
      validateToNextPassword(rule, value, callback) {
        const form = this.form;
        if (value && this.confirmDirty) {
          form.validateFields(['configPassword'], { force: true });
        }
        callback();
      },
      getData() {
        return new Promise((resolve,reject)=>{
          this.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
              console.log(values)
              values = {
                oldPassword:md5(values.oldPassword),
                password:md5(values.password),
                configPassword:md5(values.configPassword)
              }
              resolve(values)
            } else {
              reject()
              this.$message.warn('请正确输入表单')
            }
          })
        })

      }
    }
  }
</script>

<style scoped>
  .update-password-form{

  }
</style>